import PropTypes from 'prop-types';

export const FavoriteListPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  is_default: PropTypes.bool.isRequired,
  poi_ids: PropTypes.arrayOf(PropTypes.number).isRequired,
});
